// removed by extract-text-webpack-plugin
module.exports = {"fadeIn":"style__fadeIn__3VSFi","fadeOut":"style__fadeOut__2joGB","spin":"style__spin__3DhNY","b2t":"style__b2t__3nUft","t2b":"style__t2b__2EN61","l2r":"style__l2r__3MYHl","r2l":"style__r2l__1Hoad"};


//////////////////
// WEBPACK FOOTER
// ./src/theme/style.scss
// module id = 102
// module chunks = 0